// extracted by mini-css-extract-plugin
export default {"backButton":"ID1jtxAYNEyRPh5hzjgj","list":"goQQJKh0Au1gVuG2T2lY"};